
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    loadRegistrationStats: ({state, getters, commit, dispatch}, id: number) => {

        commit('setStatsLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/sub-panel/'+id+'/registration-statistics')

                .then(({data}) => {
                    commit('setStats', data.statistics);
                    commit('setStatsLoading', false);
                    resolve(null);
                })
                .catch(error => {
                    commit('setStatsLoading', false);
                    reject(error);
                })
        });
    },
};
